import { css, styled } from 'styled-components';

import { getCDNImageUrl } from '@/helpers/cdn';
import { TCardMode } from '@/modules/game/types';

const bgSrc = getCDNImageUrl('/lobbySpins.webp');

interface IScShowAllGameCardProps {
  mode: TCardMode;
  isSmall: boolean;
}

export const ScShowAllGameCard = styled.div<IScShowAllGameCardProps>`
  display: flex;
  width: 100%;
  height: calc(100% - 41px);
  padding: 0px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  border-radius: 12px;
  background: url(${bgSrc}) center no-repeat;

  &.black {
    background-color: ${({ theme }) => theme.blackColor};
  }

  &.dark {
    background-color: ${({ theme }) => theme.grayDarkColor};
  }

  &.light {
    background-color: ${({ theme }) => theme.gray1Color};
  }

  & button {
    ${({ isSmall }) =>
      isSmall
        ? css`
            min-width: auto;
            padding: 0;
            border: none;
          `
        : css`
            min-width: 100%;
          `}
  }
`;
